// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-version-number {
  color: var(--ion-color-dynamic-two);
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/shared-components/lib/native-version-info/native-version-info.component.scss"],"names":[],"mappings":"AAAA;EACI,mCAAA;AACJ","sourcesContent":[".app-version-number{\n    color: var(--ion-color-dynamic-two);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
